import { useQuery } from 'react-query'
import { hrApiService } from './index'
import { retryProtectedQuery } from 'services/session/queryPolicy'

// Hook to get all users from current user's tenant (main staff directory)
export const useHrUsers = () => {
  return useQuery(['hr-users'], () => hrApiService.getUsers(), {
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: retryProtectedQuery,
    retryDelay: 1000,
  })
}

// Hook to get basic staff directory for chat purposes (no permission required)
export const useHrBasicStaffDirectory = () => {
  return useQuery(['hr-basic-staff-directory'], () => hrApiService.getBasicStaffDirectory(), {
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: retryProtectedQuery,
    retryDelay: 1000,
  })
}

// Hook to get simple staff list with pagination and search
export const useHrSimpleStaffList = (params = {}) => {
  return useQuery(['hr-users', 'simple', params], () => hrApiService.getSimpleStaffList(params), {
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: retryProtectedQuery,
    retryDelay: 1000,
  })
}

// Hook to get users by specific tenant ID (admin endpoint)
export const useHrUsersByTenant = (tenantId) => {
  return useQuery(['hr-users', 'tenant', tenantId], () => hrApiService.getUsersByTenant(tenantId), {
    enabled: !!tenantId,
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: retryProtectedQuery,
    retryDelay: 1000,
  })
}

// Hook to get current user profile
export const useHrMyAccount = () => {
  return useQuery(['hr-my-account'], () => hrApiService.getMyAccount(), {
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: retryProtectedQuery,
    retryDelay: 1000,
  })
}

// Hook to get user by ID
export const useHrUserById = (userId) => {
  return useQuery(['hr-user', userId], () => hrApiService.getUserById(userId), {
    enabled: !!userId,
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: retryProtectedQuery,
    retryDelay: 1000,
  })
}

// Hook to search users
export const useHrSearchUsers = (query) => {
  return useQuery(['hr-users', 'search', query], () => hrApiService.searchUsers(query), {
    enabled: !!query && query.trim().length > 0,
    staleTime: 300000, // 5 minutes
    cacheTime: 600000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: retryProtectedQuery,
    retryDelay: 1000,
  })
}
